export { default as TPModal } from './component';
export * from './TPModal.proptype';
